import { Component, NgModule, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DxListModule } from 'devextreme-angular/ui/list';
import { DxContextMenuModule } from 'devextreme-angular/ui/context-menu';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { LoginResult } from 'src/app/models/login-result';

@Component({
    selector: 'app-user-panel',
    templateUrl: 'user-panel.component.html',
    styleUrls: ['./user-panel.component.scss'],
    standalone: false
})

export class UserPanelComponent {
  @Input()
  menuItems: any;

  @Input()
  menuMode: string;

  firstName: string;
  lastName: string;

  constructor(localStorageService: LocalStorageService) {
    let userInfo = localStorageService.get<LoginResult>(LoginResult.storage_key);
    this.firstName = userInfo.firstName;
    this.lastName = userInfo.lastName;
  }
}

@NgModule({
  imports: [
    DxListModule,
    DxContextMenuModule,
    CommonModule
  ],
  declarations: [ UserPanelComponent ],
  exports: [ UserPanelComponent ]
})
export class UserPanelModule { }
